module.exports = __webpack_public_path__ + "static/media/animal-sheep2.f33a958c.aac";